import axios from 'axios';
import { AppConfig } from 'AppConfig';
import { requestWithTenantSwitchRetry } from 'networking/tenantSwitchRetry';

export async function getAdHocReportsForManageSaved() {
  const response = await requestWithTenantSwitchRetry(() =>
    axios.get(`${AppConfig.FO_INITIAL_URL}/saved-reports/`)
  );
  const data = response.data || {};
  const adHocPublic = Array.isArray(data.adHocPublic) ? data.adHocPublic : [];
  const adHocPersonal = Array.isArray(data.adHocPersonal) ? data.adHocPersonal : [];

  const tag = (reports, visibility) =>
    reports.map((r) => ({
      ...r,
      reportSource: 'adhoc',
      adHocVisibility: visibility
    }));

  return [...tag(adHocPublic, 'public'), ...tag(adHocPersonal, 'private')];
}
